/**
 * The ingest sidecar is addressed by its WebSocket URL everywhere else in the
 * app (`VITE_INGEST_WS_URL`), but playback is plain HTTP against the same
 * host, so the one conversion lives here rather than in a component.
 */

/** `wss://lls-api.yogourt.dev/ws` -> `https://lls-api.yogourt.dev`. */
export function ingestHttpBase(wsUrl: string): string {
  if (wsUrl === "") return "";
  try {
    const url = new URL(wsUrl);
    url.protocol = url.protocol === "ws:" ? "http:" : "https:";
    url.pathname = "";
    url.search = "";
    return url.toString().replace(/\/+$/, "");
  } catch {
    return "";
  }
}
